import "./App.css";
import { MainProvider } from "./providers/MainProvider";

function App() {
  
  return <MainProvider />;
}

export default App;
